import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import AppRoutes from './routes/AppRoutes';
import { setCategory } from './redux/slices/categorySlice';
import { FetchCategory } from './services/api/category';
import './App.css';

function App() {
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  // Fetch categories only once when the app loads
  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      FetchCategory()
        .then((response) => {
          dispatch(setCategory(response.data));
        })
        .catch((error) => console.error("Error fetching categories:", error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array - runs only once on mount

  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;